<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <v-layout>
        <v-flex xs12 md4>
          <v-autocomplete
            :items="filteredPowerPlants"
            item-text="name"
            prepend-icon="flash_on"
            label="Planta"
            v-model="power_plant"
            return-object
            :rules="[(v) => !!v || 'Selecione a Planta que deseja ver fatura']"
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field
            v-model="competence"
            :rules="competenceRules"
            label="Competencia"
            prepend-icon="event"
            class="purple-input"
            :value="current_date"
            @keyup.enter="validate"
            mask="##/####"
          />
        </v-flex>

        <v-flex xs12 md4 d-flex>
          <v-flex xs12 md12 class="text-lg-right">
            <v-btn
              color="primary"
              @click="validate()"
              :disabled="!valid || loading"
              :loading="loading"
            >
              <v-icon>search</v-icon>Buscar
            </v-btn>
          </v-flex>
          <v-flex xs6 md6>
            <v-btn color="teal" @click="invoiceForm()" :disabled="loading">
              <v-icon>monetization_on</v-icon>Adicionar
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
import { GET_BILLING } from "../../graphql/billing";
import { eventBus } from "../../main";
import { mapState } from "vuex";
export default {
  props: ["power_plants"],
  data: () => ({
    competence: "",
    power_plant: "",
    valid: false,
    loading: false,
    invoices: [],
    current_date: new Date(),
    competenceRules: [
      (v) => !!v || "Por favor, preencher a competência da fatura.",
      (v) =>
        !(v.substr(2, 4) < 2019) ||
        "Por favor, o ano deve ser valido. " + v.substr(2, 4),
      (v) =>
        !(v.substr(0, 2) > 12) ||
        "Por favor, o mes deve ser valido. " + v.substr(0, 2),
    ],
  }),
  computed: {
    ...mapState(["user"]),
    filteredPowerPlants() {
      if (
        this.user &&
        this.user.group &&
        (this.user.group.indexOf("admin") >= 0 ||
          this.user.group.indexOf("financial") >= 0)
      )
        return this.power_plants;

      var PowerPlantArray = [];
      this.power_plants.filter((power_plant) => {
        return this.user.power_plants.filter((power_plant2) => {
          if (power_plant2.power_plant_id === power_plant.power_plant_id) {
            PowerPlantArray.push(power_plant);
          }
        });
      });
      return PowerPlantArray;
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        (this.valid = true), (this.loading = true);
        const mes = this.competence.substr(0, 2);
        const ano = this.competence.substr(2, 4);
        const newCompetence = ano + "-" + mes;
        this.$apollo
          .query({
            // gql query
            query: GET_BILLING,
            // Reactive parameters
            variables: {
              // Use vue reactive properties here
              power_plant_id: this.power_plant.power_plant_id,
              competence: newCompetence,
            },
          })
          .then((billing) => {
            // Seta as faturas no eventBus para o outro Componente
            this.invoices = billing.data.billing;
            this.setInvoices(billing.data.billing);
            this.setInvoiceTotal(billing.data.billingTotal);
            eventBus.$emit("selectBillingCompetence", {
              power_plant_id: this.power_plant.power_plant_id,
              competence: newCompetence,
              totalItems: billing.data.billingTotal.number_of_customers,
            });
            this.valid = true;
            this.loading = false;
          })
          .catch((error) => {
            console.error(error);
            this.valid = true;
            this.loading = false;
          });
      }
    },
    setInvoices(invoices) {
      if (invoices) {
        EventBus.$emit("LoadInvoices", invoices);
      } else {
        EventBus.$emit("LoadInvoices", {});
      }
    },
    setInvoiceTotal(total) {
      if (total !== undefined) {
        EventBus.$emit("InvoiceTotal", total);
      } else {
        EventBus.$emit("InvoiceTotal", {});
      }
    },
    beforeDestroy() {
      //do something before destroying vue instance
      EventBus.$off("LoadInvoices");
      EventBus.$off("InvoiceTotal");
    },
    invoiceForm() {
      EventBus.$emit("showForm", true);
    },
  },
};
</script>
